module.exports = __webpack_public_path__ + "static/media/b2_p3_narration_b.91678191.mp3";